module.exports = __webpack_public_path__ + "img/developers-icon-dark.d0634154.svg";